module.exports = __webpack_public_path__ + "img/info.24996f83.svg";